/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ScaleOneBar({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-label="Low Priority" viewBox="0 0 16 16" {...props}><rect width={3} height={6} x={1.5} y={8} rx={1} /><rect width={3} height={9} x={6.5} y={5} fillOpacity={0.4} rx={1} /><rect width={3} height={12} x={11.5} y={2} fillOpacity={0.4} rx={1} /></svg>;
}
;